<template>
  <v-container>
    <br />
    <br />
    <v-card>
      <v-card-title>
        Kilitli Cihaz Yönetimi
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="lockedUsers"
        :footer-props="{
          'items-per-page-options': [20, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="20"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.isLocked="{ item }">
          <span
            class="badge"
            :class="item.isLocked ? 'badge-passive' : 'badge-active'"
            >{{ item.isLocked ? "Kilitli" : "Kilitli Değil" }}</span
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white"
            @click="handleActivateButton(item)"
            :class="['mr-2', { disabled: !isAdmin || !item.isLocked }]"
            :disabled="!isAdmin || !item.isLocked"
          >
            Kilit Aç
          </v-btn>
          <!-- <v-icon small @click="onBoardingDelete(item)">mdi-delete</v-icon> -->
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="userPageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
      <v-dialog v-model="isActivateModalOpen" max-width="600">
        <v-card style="text-align: center">
          <v-card-title
            style="display: flex; justify-content: center"
            class="headline"
          >
            Hesap Kilidi Kaldırılacak!
          </v-card-title>

          <v-card-text>
            <ul style="text-align: start; margin-bottom: 10px">
              <li>
                <strong>Kullanıcı Adı Soyadı: </strong
                >{{ selectedUser.fullName }}
              </li>
              <li>
                <strong>Telefon Numarası: </strong
                >{{ selectedUser.phoneNumber }}
              </li>
            </ul>

            <p>
              Kilit açıldığında, kullanıcı hangi cihazdan giriş yaparsa o cihaz
              ile hesap eşleştirilecektir.
            </p>
            <v-row
              style="gap: 8px; justify-content: flex-end; margin-top: 12px"
            >
              <v-btn
                depressed
                color="error"
                @click="onClose()"
                style="text-transform: none !important"
              >
                İptal
              </v-btn>
              <v-btn
                depressed
                color="success"
                style="text-transform: none !important; color: white"
                @click="activateUser()"
              >
                Onayla
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LockedUsersManagement",
  data: () => ({
    search: "",
    isAdmin: false,
    email: "",
    isActivateModalOpen: false,
    selectedUser: {
      fullName: "",
      id: "",
      isLocked: false,
      lockDate: "",
      phoneNumber: "",
    },
    userPageData: {
      pageNumber: 1,
      pageSize: 20,
      search: "",
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    headers: [
      { text: "Kullanıcı Id", value: "id", sortable: false },
      { text: "Telefon Numarası", value: "phoneNumber", sortable: false },
      { text: "E-posta", value: "email", sortable: false },
      { text: "Ad Soyad", value: "fullName", sortable: false },
      { text: "Hesap Durumu", value: "isLocked", sortable: false },
      { text: "Kilit Tarihi", value: "lockDate", sortable: false },
      { text: "Düzenle", value: "actions", sortable: false },
    ],
    allRoles: [
      {
        id: "PanelUser",
        name: "Admin",
      },
      {
        id: "PanelVenueUser",
        name: "Üye İş Yerleri",
      },
      {
        id: "PanelReportUser",
        name: "Rapor Erişimi",
      },
      {
        id: "AppliedMerchantUser",
        name: "Başvuru Yapılmış",
      },
    ],
  }),
  computed: mapGetters(["lockedUsers", "loading"]),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1;
    this.userPageData.pageNumber = Number(page);

    this.getLockedUsers(this.userPageData).then((response) => {
      this.pagination.totalItems = response.totalCount;
      this.pagination.pagesLength = response.totalPages;
    });
    this.userRoles = JSON.parse(localStorage.getItem("userRoles"));
    this.email = localStorage.getItem("email");
    console.log("email", this.email);

    if (
      this.userRoles.find((x) => x == "PanelUser") != null &&
      this.userRoles.find((x) => x == "PanelUser") != undefined
    ) {
      this.isAdmin = true;
      console.log("admin", this.isAdmin);
    }
  },
  methods: {
    ...mapActions(["getLockedUsers", "unlockUserDevice"]),

    // Data table item per page changed function
    getItemPerPage(val) {
      this.userPageData.pageSize = val;
      this.userPageData.pageNumber = 1;

      this.getLockedUsers(this.userPageData)
        .then((response) => {
          this.pagination.pagesLength = response.totalPages;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    getPageNumber(val) {
      this.userPageData.pageNumber = val;
      if (val !== 1) {
        this.$router.push({ query: { page: val } });
      }
      this.getLockedUsers(this.userPageData);
    },

    setPageNumber(val) {
      if (
        (!this.$route.query.page && val === 1) ||
        this.$route.query.page == val
      ) {
        return;
      }
      this.$router.push({ path: this.$route.fullPath, query: { page: val } });
    },

    getItemPerSearch(val) {
      this.userPageData.pageNumber = 1;
      this.userPageData.search = val;
      this.getLockedUsers(this.userPageData)
        .then((response) => {
          this.pagination.totalItems = response.totalCount;
          this.pagination.pagesLength = response.totalPages;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    handleActivateButton(user) {
      this.selectedUser = user;
      this.isActivateModalOpen = true;
    },

    onClose() {
      this.selectedUser = {
        fullName: "",
        id: "",
        isLocked: false,
        lockDate: "",
        phoneNumber: "",
      };
      this.isActivateModalOpen = false;
    },

    async activateUser() {
      const result = await this.unlockUserDevice(this.selectedUser.id);
      this.getLockedUsers(this.userPageData);
      this.$toasted.show(
        result.payload
          ? "Hesap kilidi kaldırıldı. Kullanıcı hangi cihazdan giriş yaparsa o cihaz ile eşleştirilecektir."
          : String(result.friendlyMessage.message),
        {
          duration: 3000,
          position: "top-right",
          type: result.payload ? "success" : "error",
        },
      );
      this.onClose();
    },
  },

  watch: {
    search: function (val, oldVal) {
      if (val.length === 0) this.getItemPerSearch("");
      if (val.length < 3) return;
      this.getItemPerSearch(val);
    },
    "$route.query.page"(val) {
      const pageNumber = val ? Number(val) : 1;
      this.getPageNumber(pageNumber);
    },
    isActivateModalOpen(val) {
      if (!val) {
        this.onClose();
      }
    },
  },
};
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}
.v-data-footer__icons-after {
  display: none;
}
.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.badge-active {
  background-color: #e6f7f0;
  color: #2e7d32;
}

.badge-passive {
  background-color: #fdecea;
  color: #c62828;
}
</style>
